// 案件一覧マイページの「ご案内一覧」タブ

import { MDBDataTable } from 'mdbreact';
import React from 'react';
import { Button } from 'react-bootstrap';
import Moment from 'moment';
import Annotation from '../atoms/Annotation';
import { InformationItem } from '../types/ProjectList';
import { addEllipsis } from '../Common';

interface Props {
  datas: InformationItem[];
}

interface RowItem {
  id: number;
  office: string | null;
  title: string | null;
  start_date: string | null;
  button: JSX.Element | null;
}

const GuideList: React.FC<Props> = ({datas}) => {
  const columns = [
    {
      label: 'JA店舗名',
      field: 'office',
      sorc: 'asc',
      width: 80,
    },
    {
      label: 'タイトル',
      field: 'title',
      sorc: 'asc',
      width: 180,
    },

    {
      label: '掲載日',
      field: 'start_date',
      sorc: 'asc',
      width: 80,
    },
    {
      label: '詳細',
      field: 'button',
      sorc: 'asc',
      width: 60,
    },
  ];

  // datasを整形して結果を返却する
  const dataShaping = () => {
    const list: RowItem[] = [];

    datas.map((data, index) => {
      const item: RowItem = {
        id: 0,
        office: null,
        title: null,
        start_date: null,
        button: null,
      };

      item.id = data.id;
      item.office = data.office;

      // 字数が15文字よりも多い場合は、16文字目以降を省略する
      item.title = addEllipsis(data.title);
      item.start_date = Moment(data.start_date).format('YYYY/MM/DD');

      // 詳細ボタンをセットする
      item.button = (
        <Button
          variant="outline-success"
          href={`${location.origin}${process.env.MIX_MOCK_URL}/mypage/customer_document/detail?id=${item.id}`}
          className="btn-text-color"
          key={`detail-${index}`}
        >
          詳細
        </Button>
      );

      list.push(item);
    });

    return list;
  };

  return (
    <>
      <Annotation text="詳しい内容を確認したい場合は、「詳細」ボタンを押して下さい。" />

      <MDBDataTable
        hover
        entries={20}
        data={{
          columns: columns,
          rows: dataShaping(),
        }}
        displayEntries={false}
        info={false}
        paging={false}
        searching={false}
        sortable={false}
        entriesLabel=""
        noBottomColumns
        noRecordsFoundLabel="該当する情報が見つかりません"
        key="mdbdatatable"
      />
    </>
  );
};

export default GuideList;
